import React, { ReactElement, useState } from 'react';
import { Form, Select } from 'antd';
import { isEmpty } from 'lodash';

import { Nullable } from 'types';
import useBreedVarieties from 'pricing/hooks/useBreedVarieties/useBreedVarieties';
import { testId } from 'pricing/utilities/test/dataTestId';

function FieldPuppyVarieties(): ReactElement {
  const [breedId, setBreedId] = useState<Nullable<number>>(null);
  const { breedVarieties } = useBreedVarieties(breedId);

  return (
    <Form.Item
      noStyle
      shouldUpdate={(prevValues, curValues) => {
        if (prevValues.breedId !== curValues.breedId) {
          setBreedId(curValues.breedId);
        }
        return prevValues.breedId !== curValues.breedId;
      }}
    >
      {(form) => {
        const breedId = form.getFieldValue('breedId');

        return (
          <Form.Item
            name="varietyIds"
            label="Variety"
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
          >
            <Select
              disabled={!breedId || isEmpty(breedVarieties)}
              data-testid={testId.fieldPuppyVarieties}
              placeholder="Select"
              mode="multiple"
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {breedVarieties.map((variety) => (
                <Select.Option
                  data-testid={testId.fieldPuppyVarietyOption}
                  key={variety.id}
                  value={variety.id}
                >
                  {variety.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        );
      }}
    </Form.Item>
  );
}

export default FieldPuppyVarieties;
